import { useAuthActions } from "@convex-dev/auth/react";
import { Link } from "react-router";
import { Settings } from "lucide-react";
import { Button, Navbar } from "@repo/ui";

export function AdminNavbar() {
  const { signOut } = useAuthActions();

  // Pas de menu : la navigation est hiérarchique depuis la page d'accueil, et
  // c'est le fil d'Ariane de chaque page qui situe et fait remonter. Seuls les
  // paramètres, transverses à toutes les organisations, ont leur raccourci.
  return (
    <Navbar
      title="Portail Admin"
      onLogout={signOut}
      rightContent={
        <Button variant="ghost" size="icon" asChild>
          <Link to="/parametres" aria-label="Paramètres" title="Paramètres">
            <Settings className="h-4 w-4" />
          </Link>
        </Button>
      }
    />
  );
}
